import WebVideo from "./webVideo.container";

export default WebVideo;
